import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import atualizalocal from './modules/atualizalocal';
import auth from './modules/auth';
import users from './modules/users';
import aberturalote from './modules/aberturalote';
import empresa from './modules/empresa';
import permissao from './modules/permissao';
import apontamentoproducao from './modules/apontamentoproducao';
import modulos from './modules/modulos';
import cache from './modules/cache';
import ordemcarregamento from './modules/ordemcarregamento';
import resultadosecagem from './modules/resultadosecagem';
import filter from './modules/filter';
import controlearmazenamento from './modules/controlearmazenamento';
import portariachecklist from './modules/portariachecklist';
// import debug from './modules/debug';

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    async $_setup({ dispatch }) {
      await dispatch('auth/$_setup');
    },
  },

  modules: {
    atualizalocal,
    auth,
    users,
    aberturalote,
    empresa,
    permissao,
    apontamentoproducao,
    modulos,
    cache,
    ordemcarregamento,
    resultadosecagem,
    filter,
    controlearmazenamento,
    portariachecklist,
    //debug
  }, 
  plugins: [createPersistedState({
    paths: [''],
    storage: window.sessionStorage,
  })],
});
